import { Typography } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

const TeamDeleteConfirmationModal = (props: ConfirmationModalProps) => (
  <ConfirmationModal
    title="Delete Team?"
    confirmProps={{ label: "Delete", type: "negative" }}
    {...props}
  >
    <Typography>
      Are you sure you want to delete this team? This action is permanent and
      cannot be undone. All team members will be notified.
    </Typography>
  </ConfirmationModal>
);

export default TeamDeleteConfirmationModal;
